import Link, { LinkProps } from "next/link";
import React from "react";

type MarbleLinkProps = LinkProps &
  Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps> & {
    children?: React.ReactNode;
  };

export function MarbleLink({
  prefetch = false,
  children,
  ...props
}: MarbleLinkProps) {
  return (
    <Link prefetch={prefetch} {...props}>
      {children}
    </Link>
  );
}
